import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/lib/i18n";
import { LangToggle } from "@/components/LangToggle";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  React.useEffect(() => { if (user) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    const r = await login(email, pw);
    setBusy(false);
    if (r.ok) nav("/admin");
    else setErr(r.error);
  };

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <img src="/corp-logo.png" alt="Relax-MIS" className="h-10 w-auto" />
          <LangToggle variant="light" />
        </div>
      </header>

      <main className="max-w-md mx-auto px-6 py-16">
        <div className="rounded-xl border border-stone-200 shadow-sm p-8 bg-white">
          <div className="caption-label mb-2">Super Admin Console</div>
          <h1 className="font-serif text-4xl text-stone-900 mb-1">{t("admin.login.title")}</h1>
          <p className="text-stone-500 text-sm mb-6">{t("admin.login.subtitle")}</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="caption-label">{t("admin.login.email")}</label>
              <Input
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1"
                placeholder="you@example.com"
                data-testid="admin-login-email"
                required
              />
            </div>
            <div>
              <label className="caption-label">{t("admin.login.password")}</label>
              <Input
                type="password"
                autoComplete="current-password"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                className="mt-1"
                data-testid="admin-login-password"
                required
              />
            </div>
            {err && <div className="text-red-600 text-sm" data-testid="admin-login-error">{err}</div>}
            <Button
              type="submit"
              disabled={busy}
              className="w-full bg-emerald-800 hover:bg-emerald-900 text-amber-50 font-medium tracking-wide"
              data-testid="admin-login-submit"
            >
              {busy ? "…" : t("admin.login.submit")}
            </Button>
          </form>
          <div className="text-center mt-4">
            <Link to="/forgot-password" className="text-emerald-800 text-sm hover:text-emerald-900 underline underline-offset-4" data-testid="admin-forgot-link">
              {t("admin.login.forgot")}
            </Link>
          </div>
        </div>

        <div className="text-stone-400 text-xs mt-6 text-center font-mono">
          {t("admin.login.demo_hint")} <Link to="/baan-thai-massage-demo-88-sukhumvit-soi-11-bangkok" className="underline hover:text-stone-700" data-testid="admin-login-demo-link">/baan-thai-massage-demo-88-sukhumvit-soi-11-bangkok</Link>
        </div>
      </main>
    </div>
  );
}
